<template>
	<div class="uplimit_step_table">
		<!-- {{stock_info}} -->
		<div v-b-toggle.sidebar-right-stock @click="show_sidebar(stock_info)"
			v-b-popover.hover.top="" :title="stock_info['up_limit_desc']+'['+stock_info['up_limit_type']+']'"
			>
			<span v-if="show_time" :style="getTimeStyle(stock_info['up_limit_time'])">{{ stock_info['up_limit_time'] }}</span>
			<span v-if="is_show_market" :style="getPercentFontStyle(market['px_change_rate'])">
				{{" "+stock_info['stock_name']+" "+(market['px_change_rate']==0?'':market['px_change_rate'])}}
			</span>
			<span v-else>{{" "+stock_info['stock_name']}}</span>
	
			<span v-if="show_amount && stock_info['amount']" class="amount-text" :class="{'high-amount': isHighAmount}">
				{{stock_info['amount']}}
			</span>
			<span v-if="show_market_value && stock_info['market_c']" class="amount-text" :class="{'high-amount': isHighMarketC}">
				{{stock_info['market_c']}}
			</span>
			<span v-if="show_circulating_value && stock_info['market_c_c']" class="amount-text">
				{{stock_info['market_c_c']}}
			</span>
			<span v-if="show_sealed_order && stock_info['fd_close']" class="amount-text" :class="{'high-amount': isHighFd}">
				{{stock_info['fd_close']+"/"+stock_info['fd_max']}}
			</span>
			
			<span v-if="stock_info && stock_info.stock_code && stock_info.stock_code.startsWith('30')" class="circle-c">ⓒ</span>
			<span v-else-if="stock_info && stock_info.stock_code && stock_info.stock_code.startsWith('8')" class="circle-b">Ⓑ</span>
			<span v-else-if="stock_info && stock_info.stock_code && stock_info.stock_code.startsWith('68')" class="circle-k">Ⓚ</span>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		props: {
			stock_info: Object,
			is_show_market: {
				type: Number,
				default: 0
			},
			market: {
				type: Object,
				default: undefined
			},
			show_time: {
				type: Number,
				default: 1
			},
			show_amount: {
				type: Number,
				default: 0
			},
			show_market_value: {
				type: Number,
				default: 0
			},
			show_circulating_value: {
				type: Number,
				default: 0
			},
			show_sealed_order: {
				type: Number,
				default: 0
			}
		},
		methods: {
			show_sidebar(stock_info) {
				this.$emit('show_sidebar', stock_info)
			},
			getGradientColor(start_color, end_color, percent) {
				// strip the leading # if it's there
				start_color = start_color.replace(/^\s*#|\s*$/g, '');
				end_color = end_color.replace(/^\s*#|\s*$/g, '');

				// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
				if (start_color.length == 3) {
					start_color = start_color.replace(/(.)/g, '$1$1');
				}

				if (end_color.length == 3) {
					end_color = end_color.replace(/(.)/g, '$1$1');
				}

				// get colors
				function parse(rgb, i) {
					return parseInt(rgb.substr(i, 2), 16)
				}

				let start_r = parse(start_color, 0),
					start_g = parse(start_color, 2),
					start_b = parse(start_color, 4);

				let end_r = parse(end_color, 0),
					end_g = parse(end_color, 2),
					end_b = parse(end_color, 4);

				// calculate new color
				let r = end_r - start_r;
				let g = end_g - start_g;
				let b = end_b - start_b;

				r = ((r * percent) + start_r)
				g = ((g * percent) + start_g)
				b = ((b * percent) + start_b)

				function hex(x) {
					let h = x.toString(16).split('.')[0].toUpperCase()
					return (h.length == 1) ? '0' + h : h
				}

				return '#' + hex(r) + hex(g) + hex(b)
			},

			getPercentColor(pt) {
				const isDark = document.body.classList.contains('theme-dark');
				const baseColor = isDark ? '#1e293b' : '#FFFFFF';
				if (pt >= 0) {
					if (pt > +10) {
						pt = +10;
					}
					pt = +pt / 10;
					return this.getGradientColor(baseColor, '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10;
					}
					pt = -pt / 10;
					return this.getGradientColor(baseColor, '#278B22', pt)
				}
			},

			getPercentStyle(pt) {
				return {
					'background': this.getPercentColor(pt)
				}
			},
			// 按涨跌幅获取渐变颜色(-10,+10)，适合字体
			getPercentColorFont(pt) {
				const isDark = document.body.classList.contains('theme-dark');
				if (pt === 0) {
					return isDark ? '#e5e5e5' : '#111111'
				} else if (pt > 0) {
					pt = +pt / 10
					const start = isDark ? '#f87171' : '#FF99CC';
					return this.getGradientColor(start, '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10
					}
					pt = -pt / 10
					const start = isDark ? '#4ade80' : '#66FF55';
					return this.getGradientColor(start, '#278B22', pt)
				}
			},
			getPercentFontStyle(pt) {
				return {
					'color': this.getPercentColorFont(pt)
				}
			},
			getTimeStyle(time) {
				const isDark = document.body.classList.contains('theme-dark');
				let color = isDark ? '#e5e5e5' : '#000000'; // 默认颜色
				if (!time) return { color };

				// 假设时间格式为 HH:mm 或 HH:mm:ss，仅取前两部分
				const parts = time.split(':');
				if (parts.length < 2) return { color };
				const hours = parseInt(parts[0], 10);
				const minutes = parseInt(parts[1], 10);
				if (isNaN(hours) || isNaN(minutes)) return { color };
				const totalMinutes = hours * 60 + minutes;

				// 09:30 - 10:00（570~600分钟）：深红色
				if (totalMinutes >= 570 && totalMinutes < 600) {
					color = isDark ? '#ff6b6b' : 'darkred';
				}
				// 10:00 - 10:30（600~630分钟）：红色
				else if (totalMinutes >= 600 && totalMinutes < 630) {
					color = isDark ? '#ff4d4f' : 'red';
				}
				// 10:30 - 11:30（630~690分钟）：橙色
				else if (totalMinutes >= 630 && totalMinutes < 690) {
					color = isDark ? '#ffa940' : 'orange';
				}
				// 13:00 - 14:00（780~840分钟）：蓝色
				else if (totalMinutes >= 780 && totalMinutes < 840) {
					color = isDark ? '#69c0ff' : '#003366'; // Darker blue for light mode
				}
				// 14:00 - 15:00（840~900分钟）：天蓝色
				else if (totalMinutes >= 840 && totalMinutes < 900) {
					color = isDark ? '#91d5ff' : '#0066cc'; // Better contrast blue
				}

				return { color };
			}
		},
		computed: {

			isHighAmount() {
				if (!this.stock_info || !this.stock_info.amount) return false;
				
				const amount = parseFloat(this.stock_info.amount);
				if (isNaN(amount)) return false;
				
				// 如果股票代码以30开头，且成交额大于30亿，则标记红色
				if (this.stock_info.stock_code && this.stock_info.stock_code.startsWith('30')) {
					return amount > 3;
				}
				// 否则，如果成交额大于90亿，则标记红色
				return amount > 9;
			},
			isHighMarketC() {
				if (!this.stock_info || !this.stock_info.market_c) return false;
				
				const market_c = parseFloat(this.stock_info.market_c);
				if (isNaN(market_c)) return false;
				
				// 如果股票代码以30开头，且成交额大于30亿，则标记红色
				if (this.stock_info.stock_code && this.stock_info.stock_code.startsWith('30')) {
					return market_c > 30;
				}
				// 否则，如果成交额大于90亿，则标记红色
				return market_c > 90;
			},
			isHighFd() {
				if (!this.stock_info ||!this.stock_info.fd_close) return false;

				const fd_close = parseFloat(this.stock_info.fd_close);
				const fd_max = parseFloat(this.stock_info.fd_max);
				if (isNaN(fd_close) || isNaN(fd_max)) return false;

				return fd_close > 2 && fd_max > 5;
			}
		}
	}
</script>

<style>
	.uplimit_step_table {}

.circle-c {
		color: #fc0280;
		font-size: 12px;
		line-height: 1;
		vertical-align: middle;
}

.circle-b {
		color: #f10101;
		font-size: 12px;
		line-height: 1;
		vertical-align: middle;
}

.circle-k {
		color: #ff6600;
		font-size: 12px;
		line-height: 1;
		vertical-align: middle;
}

	.amount-text {
		color: var(--text-muted, #666);
		font-size: 0.9em;
	}

	.high-amount {
		color: hsl(0, 88%, 65%);
	}
</style>
